import { render, staticRenderFns } from "./mytasks.vue?vue&type=template&id=5d5921e8"
import script from "./mytasks.vue?vue&type=script&lang=js"
export * from "./mytasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports